import request from '@/utils/request'
import { getLegacyShapedCombos } from '@/services/combo/apis'
import { buildGoodsCodeOptionsUrl, buildInventoryStatusesUrl } from './endpoints'
import { GetGoodsCodeOptionsReq, GetInventoryStatusesReq, GoodsCodeOption, InventoryStatusItem } from './types'

export { INVENTORY_STATUSES_URL, INVENTORY_STATUSES_EXCEL_URL, buildInventoryStatusesExcelUrl } from './endpoints'

/**
 * ST02 재고현황 조회. (LOGISPRD-9592)
 *
 * 서버 페이징이 없어 조건에 걸린 전건이 한 번에 온다(1.0 동등) — 페이징·정렬·그룹핑은 그리드가 담당한다.
 * 사용자 필터가 모두 비면 BE 가 400 을 준다(OPR_INV 전건 스캔 방지). 화면은 화주유형/화주명과 센터명을
 * 필수로 막아 이 경우에 도달하지 않는다.
 */
export const getInventoryStatuses = (params: GetInventoryStatusesReq) =>
  request.get<ApiResponseV2<{ items: InventoryStatusItem[] }>>(buildInventoryStatusesUrl(params))

/**
 * 상품코드 서치헬퍼 목록. (LOGISPRD-9955 — 1.0 `GDS_CD_SearchForm` 이관)
 *
 * 무페이징 distinct 목록이라 응답 전건이 모달 그리드에 실린다. 화주 상품 수가 많으면 응답이 커질 수 있어
 * 로그인 세션 화주로 범위를 좁혀 조회한다.
 */
export const getGoodsCodeOptions = (params: GetGoodsCodeOptionsReq) =>
  request.get<ApiResponseV2<{ items: GoodsCodeOption[] }>>(buildGoodsCodeOptionsUrl(params))

/** 센터명 콤보. 콤보관리(MOMS_COMBO_INFO) `WH_NM` 를 2.0 콤보 API 로 받아 1.0 모양으로 돌려준다 (LOGISPRD-14161). */
export const getWarehouseNameCombo = () => getLegacyShapedCombos(['WH_NM'])
